<style lang="less" scoped>
.cloud_shopBox {
  // background-color: #fff;
}
.filtersResult {
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
  }
}
.nowBox {
  width: 100%;
  padding: 0 5px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  position: relative;
  font-size: 18px;
  cursor: pointer;
  color: #6c6c6c;
  div:not(:last-child) {
    margin-right: 40px;
  }
  .shopCar {
    position: absolute;
    right: 30px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
      position: relative;
      width: 36px;
      height: 36px;
      img {
        width: 100%;
        height: 100%;
      }
      span {
        position: absolute;
        right: -10px;
        top: -10px;
        background-color: #f25e5e;
        color: #fff;
        font-size: 16px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
      }
    }
  }
}
/* .nowBox div{
      margin-right:40px;
      font-size: 18px;
      cursor: pointer;
      color:#6c6c6c;
    } */
.cloud_shop {
  .filterDisplay {
    margin: 24px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .searchingInput {
    width: 500px;
    display: inline-block;
    margin-right: 64px;
  }
  li {
    list-style: none;
  }
  .cursor {
    cursor: pointer;
  }
  width: 1440px;
  height: auto;
  font-size: 18px;
  margin: 0 auto;
  text-align: left;
  .title {
    font-size: 26px;
    font-weight: bold;
    padding: 25px 0 20px;
  }
  .filter {
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    position: relative;
    .cloudeSelect {
      display: flex;
      align-items: center;
      .el-popper {
        .popper__arrow {
          // 隐藏下拉框的三角
          display: none;
        }
      }
      .el-select {
        width: 120px;
        font-size: 16px;
        margin-right: 20px;
      }
      // select{
      //     width: 96px;
      //     height: 30px;
      //     outline: none;
      //     border-radius:6px;
      //     border:1px solid rgba(102,102,102,1);
      //     margin-right: 28px;
      //     .option{
      //         display: inline-block;
      //         width: 96px;
      //         height: 30px;
      //         outline: none;
      //         padding-left: 10px;
      //     }
      // }
    }
    .cloundSearch {
      width: 500px;
      height: 30px;
      position: relative;
      background-color: #f3f3f3;
      padding-left: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 50px;
      margin-left: 64px;
      > input {
        background-color: #f3f3f3;
        border: none;
        outline: none;
        height: 24px;
        width: 420px;
      }
      .searchClose {
        height: 10px;
        width: 10px;
      }
      .searchImg {
        margin-right: 14px;
      }
      > div {
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .shopCar {
      position: absolute;
      right: 30px;
      top: 14px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        position: relative;
        width: 36px;
        height: 36px;
        img {
          width: 100%;
          height: 100%;
        }
        span {
          position: absolute;
          right: -10px;
          top: -10px;
          background-color: #f25e5e;
          color: #fff;
          font-size: 16px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
        }
      }
    }
  }
  .content {
    margin-top: 24px;
    background-color: transparent;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    .specMenu {
      > div {
        text-align: center;
        line-height: 3em;
        &.active {
          color: #2264dd;
        }
      }
    }
    > div {
      background-color: white;
      &:not(:last-child) {
        margin-right: 30px;
      }
      &:first-child {
        width: 200px;
      }
      &:last-child {
        flex: 1;
        display: grid;
        width: 1px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }

    .product {
      padding: 20px;
      // width: 450px;
      // height: 260px;
      display: flex;
      margin: 0 45px 35px 0;
      border: 1px solid rgba(0, 0, 0, 0);
      &:nth-of-type(3n) {
        margin: 0 0 35px 0;
      }

      /*  &:nth-child(10n+2){
                    margin: 0 45px 35px;
                }
                &:nth-child(10n+5){
                    margin: 0 45px 35px;
                }
                &:nth-child(10n+8){
                    margin: 0 45px 35px;
                } */
      .productImg {
        width: 100px;
        height: 100px;
        border-radius: 16px;
        // overflow: hidden;
        position: relative;
        cursor: pointer;
        > img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
        > div {
          // position: absolute;
          // bottom: 0;
          // left: 0;
          // width: 100%;
          min-height: 36px;
          z-index: 1;
          text-align: center;
          // background: rgba(0, 0, 0, 1);
          opacity: 0.6;
          border-radius: 0px 0px 16px 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 14px;
          // > div {
          //   width: 16px;
          //   height: 16px;
          //   margin-right: 6px;
          //   img {
          //     width: 100%;
          //     height: 100%;
          //     object-fit:cover;
          //   }
          // }
          p {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
      > ul {
        margin-left: 20px;
        margin-bottom: 0;
        width: 170px;
        display: flex;
        flex-flow: column;
        justify-content: space-evenly;
        > li {
          /*  margin-bottom: 4px; */
          color: #4d4d4d;
          &.thick {
            width: 170px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.color {
            width: 170px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.spec {
            width: 170px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.price {
            /*  margin-top: 12px; */
            font-weight: bold;
            span {
              font-size: 13px;
            }
            .oldPrice {
              color: #333;
            }
            .vipPrice {
              color: #f25e5e;
            }
            .oriPrice {
              color: rgba(0, 0, 0, 1);
              font-weight: normal;
              text-decoration: line-through;
            }
          }
          &.supplier {
            cursor: pointer;
            font-size: 14px;
            span {
              color: blue;
            }
            i {
              color: blue;
            }
          }
          &.selfSupport {
            > div {
              width: 40px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              border: 1px solid #9c9c9c;
              border-radius: 6px;
              font-size: 14px;
              color: #dfa060;
            }
          }
        }
        .addCar {
          width: 150px;
          height: 35px;
          border: 1px solid rgba(51, 51, 51, 1);
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          // margin-top: 35px;
          > div {
            width: 24px;
            height: 24px;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .product:hover {
      border: 1px solid rgba(243, 104, 0, 1);
      border-radius: 16px;
    }
  }
  .cloudPage {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .supplier_classify_box {
    height: 60px;
    /*  background-color: #fff; */
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding: 0 20px;
    position: relative;
    .totalSupplier {
      cursor: pointer;
      font-size: 16px;
      margin-right: 20px;

      /* text-decoration: underline; */
    }
    .active {
      font-weight: bold;
      border-bottom: 1px solid #404040;
    }
    .el-select {
      margin-right: 20px;
    }
    /* .el-select .el-input.is-focus .el-input__inner{
                border-color: #6851ff;
            }
            .el-select .el-input__inner:focus{
                border-color: #6851ff;
            }
            .el-select-dropdown__item.selected{
                color: #6851ff;
            } */
  }
}
</style>
<template>
  <div class="cloud_shopBox">
    <div class="cloud_shop" v-show="shoppingMallShow">
      <div class="searchingArea">
        <div class="filterDisplay">
          <div class="filtersResult">
            <span
              >筛选分类
              <i class="el-breadcrumb__separator el-icon-arrow-right"></i
            ></span>
            <el-tag
              style="margin-right: 10px"
              :closable="
                filter.key !== 'supplier' && filter.key !== 'goodsType'
              "
              v-for="(filter, index) in filterResults"
              size="small"
              :key="index"
              @close="handleTagClose(filter.key)"
              effect="plain"
              type="info"
              >{{ filter.type }}:{{ filter.label }}</el-tag
            >
          </div>
          <div style="display: flex; align-items: center">
            <div class="searchingInput">
              <gweb-searching-input
                :placeholder="searchingPlaceholder"
                v-model="productName"
                @onSearch="handleProductNameSearch"
              />
            </div>
            <span
              @click="goToOrders"
              style="margin-right: 20px; cursor: pointer; color: blue"
              >我的订单</span
            >
            <gweb-shopcar-btn
              type="dot"
              :status="shopCarStatus"
              @onClick="gotoShopCar"
            />
          </div>
        </div>
        <div class="filterGroup">
          <gweb-multi-prop-filter
            :rows="filterRows"
            v-model="filters"
            @onChange="handleFilterChange"
          />
        </div>
      </div>
      <div class="content">
        <div class="specMenu">
          <div
            :class="[index == widthRangeIndex ? 'active' : '']"
            v-for="(item, index) in widthRangeList"
            :key="index"
            @click="changeWidthRange(index)"
          >
            {{ item }}
          </div>
        </div>
        <!-- 板材列表 -->
        <div>
          <div class="product" v-for="item in productList" :key="item.id">
            <div class="productImg" @click="commodityDetails(item)">
              <!-- 后续要增加除板材外商品未添加图片给默认图片 -->
              <img
                :src="
                  item.picture
                    ? item.picture[0].url +
                      '?x-oss-process=image/resize,m_lfit,h_220,w_220'
                    : ''
                "
                alt="请上传图片"
              />
              <div>
                <p :title="item.name">{{ item.name }}</p>
              </div>
            </div>
            <!--  <div class="productImg" v-if="now == '封边'" @click="commodityDetails(item.ids,item.color_url,item.color_name,item.supplier_id)">
                          <img :src="item.color_url+'?x-oss-process=image/resize,m_fill,h_220,w_220'" alt="请上传图片">
                          <div>
                              <p>{{item.supplier_name}}</p>
                          </div>
                      </div> -->
          </div>
        </div>
      </div>
      <div class="cloudPage">
        <el-button plain v-show="page != 1" @click="getMore('re')"
          >上一页</el-button
        ><el-button v-show="page < allpage" plain @click="getMore('add')"
          >下一页</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import autoLogin from "../../util/autoLogin";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
import { getProvinceData } from "../../util/processingData";

import { ShopCarButton, SearchInput, MultiPropFilter } from "gweb_ui";
// import MultiPropFilter from '../../components/gweb_ui_test/MultiPropFilter'

const categorys = [
  {
    type: "cabinet",
    name: "柜体",
  },
  {
    type: "shutter",
    name: "门窗",
  },
  {
    type: "woodenDoor",
    name: "木门",
  },
  {
    type: "furniture",
    name: "家具",
  },
  {
    type: "other",
    name: "其他",
  },
];

export default {
  components: {
    [ShopCarButton.name]: ShopCarButton,
    [SearchInput.name]: SearchInput,
    [MultiPropFilter.name]: MultiPropFilter,
  },
  data() {
    return {
      defaultSupplierUid: "",
      defaultSupplierId: "",
      supplierList: [],
      filters: {
        area: {
          value: "120100",
          label: "四川省/成都市",
          type: "地区",
        },
        supplier: {
          value: 11715,
          label: "",
          type: "门店",
        },
        goodsType: {
          value: "",
          label: "",
          type: "商品",
        },
        goodsSubType: {
          value: 0,
          label: "",
          type: "分类",
        },
      },
      widthRangeIndex: 0,
      widthRangeList: [],
      supplierSelections: [],
      productCategorys: [],

      productName: "",
      defaultUrl: require("../../assets/timg1.png"),
      now: "板材",
      com_type: "plank",
      navList: ["板材", "五金", "封边", "柜门", "其他"],
      options: {
        type: [
          {
            value: "所有板材",
            label: "所有板材",
          },
        ],
        thick: [
          {
            value: "所有基材",
            label: "所有基材",
          },
          {
            value: "多层实木",
            label: "多层实木",
          },
          {
            value: "颗粒板",
            label: "颗粒板",
          },
        ],
        hardware: [
          {
            value: "所有五金",
            label: "所有五金",
          },
          {
            value: "连接件",
            label: "连接件",
          },
          {
            value: "铰链",
            label: "铰链",
          },
          {
            value: "螺丝",
            label: "螺丝",
          },
          {
            value: "拉手",
            label: "拉手",
          },
          {
            value: "其他",
            label: "其他",
          },
        ],
        door: [
          {
            value: "所有门板",
            label: "所有门板",
          },
          {
            value: "平开门",
            label: "平开门",
          },
          {
            value: "移门",
            label: "移门",
          },
        ],
        other: [
          {
            value: "所有分类",
            label: "所有分类",
          },
          {
            value: "包装纸板",
            label: "包装纸板",
          },
          {
            value: "数控其他",
            label: "数控其他",
          },
        ],
      },

      //商城限显示
      shoppingMallShow: true,
      //商品详情
      commodityDetailsShow: false,

      ids: [], //传递的商品ids
      color_img: "", //传递的色卡
      color_name: "", //传递的色卡名
      uid: "", //传递的uid
      //分厂分类
      subWarehouseOptions: [],
      subWarehouseValue: "",
      //总仓分类
      totalWarehouseOptions: [],
      totalWarehouseValue: "成都总仓",
      //供应商分类
      supplierOptions: [],
      supplierValue: "",
      //供应商id（用于供应商筛选）,默认0，获取所有供应商的商品
      supplierId: 19,
      isActive: true,

      goodsAttribute: {
        plank: [
          {
            text: "基材",
            value: "substrate",
          },
          {
            text: "分类",
            value: "brand_type",
          },
          {
            text: "规格",
            value: "spec",
          },
          {
            text: "厚度",
            value: "thick",
          },
          {
            text: "颜色",
            value: "color_name",
          },
        ],
        hardware: [
          {
            text: "名称",
            value: "name",
          } /* ,{
                        text:'分类',
                        value:'brand_type'
                    } */,
          {
            text: "品牌",
            value: "brand",
          },
          {
            text: "颜色",
            value: "color",
          },
          {
            text: "材质",
            value: "material",
          },
          {
            text: "规格",
            value: "spec",
          },
        ],
        edge: [
          {
            text: "发布",
            value: "supplier_name",
          },
          {
            text: "材质",
            value: "material",
          },
          {
            text: "颜色",
            value: "color_name",
          },
          {
            text: "宽度",
            value: "width",
          },
          {
            text: "厚度",
            value: "thick",
          },
          {
            text: "规格",
            value: "spec",
          },
        ],
        door: [
          {
            text: "名称",
            value: "name",
          } /* ,{
                        text:'分类',
                        value:'brand_type'
                    } */,
          {
            text: "颜色",
            value: "color",
          },
          {
            text: "材质",
            value: "material",
          },
          {
            text: "厚度",
            value: "thick",
          },
          {
            text: "规格",
            value: "spec",
          },
        ],
        other: [
          {
            text: "名称",
            value: "name",
          } /* ,{
                        text:'分类',
                        value:'brand_type'
                    } */,
          {
            text: "品牌",
            value: "brand",
          },
          {
            text: "颜色",
            value: "color",
          },
          {
            text: "材质",
            value: "material",
          },
          {
            text: "规格",
            value: "spec",
          },
        ],
      },
      seachValue: "",
      page_flag: 1, //1为显示包括库存为0
      type: "板材分类",
      thick: "基材分类 ",
      hardware: "五金分类",
      door: "门板分类",
      other: "其他分类",
      getType: "", //二级分类 板材筛选
      getThick: "", //二级分类 基材筛选

      page: 1,
      allpage: 1,
      productList: [
        {
          picture: [
            {
              url: "",
            },
          ],
        },
      ],
      carShow: false,
      sid: -1,
      shopCarNum: 0,
    };
  },
  methods: {
    // 修改宽度范围
    changeWidthRange(index) {
      this.widthRangeIndex = index;
      this.getProductList(1);
    },
    // 跳转到订单页
    goToOrders() {
      this.$router.push({
        name: "personalCenterOrders",
      });
    },
    // 筛选条件变更处理函数
    async handleFilterChange(options) {
      // 清空搜索框
      this.productName = "";
      const key = options.key;
      switch (key) {
        case "area":
          this.filters.area.label = options.value
            .map((item) => {
              return item.label;
            })
            .join("/");
          await this.getSupplierList();
          this.filters.supplier.value = this.supplierList[0].uid;
          this.filters.supplier.label = this.supplierList[0].name;
          this.filters.supplier.supplier_id = this.supplierList[0].supplier_id;
          await this.getProductCategorys(
            this.supplierList[0].uid,
            this.supplierList[0].supplier_id
          );
          break;
        case "supplier":
          await this.getProductCategorys(
            options.value.value,
            options.value.supplier_id
          );
          break;
        case "goodsType": {
          const goodsType = this.productCategorys.find((item) => {
            return options.value.value == item.value;
          });
          this.filters.goodsSubType.value = goodsType.subTypes[0]
            ? goodsType.subTypes[0].value
            : "";
          this.filters.goodsSubType.label = goodsType.subTypes[0]
            ? goodsType.subTypes[0].label
            : "";
          break;
        }
      }
      // 无论哪个筛选项发生改变，都要引起宽度范围数据改变，以及商品的重新拉取
      await this.getWidthRangeSelections();
      this.getProductList(1);
    },

    // 根据当前过滤条件中的supplier,goodsType,goodsSubType获取宽度范围选项数据
    getWidthRangeSelections() {
      return new Promise((resolve, reject) => {
        const payload = {
          uid: this.filters.supplier.value,
          supplier_id: this.filters.supplier.supplier_id,
          type: this.filters.goodsType.value,
        };
        if (this.filters.goodsSubType.value) {
          payload.brand_type_id = this.filters.goodsSubType.value;
        }
        this.$post(
          "/py/erp/get_model_spec_count",
          payload,
          (res) => {
            if (res.status == 1) {
              this.widthRangeList = res.data.width_scope
                ? Object.keys(res.data.width_scope)
                : [];
              this.widthRangeIndex = 0;
            } else {
              this.widthRangeList = [];
              this.widthRangeIndex = 0;
            }
            resolve();
          },
          () => {
            reject();
          }
        );
      });
    },

    // 根据筛选条件获取商品列表
    getProductList(page) {
      if (page) {
        this.page = page;
      }
      let url = "/py/erp/get_product_list_standard";
      let listName = "commodity_list";
      let keywordName = "name";
      // switch (this.filters.goodsType.value) {
      //   case "plank":
      //   case "edge":
      //     url = "/py/erp/get_edge_commodity";
      //     listName = "data_list";
      //     keywordName = "color_name";
      //     break;
      //   case "hardware":
      //   case "door":
      //   case "other":
      //     url = "/py/erp/get_other_commodity";
      //     break;
      //   default:
      //     url = "/py/erp/get_other_commodity";
      //     break;
      // }
      const params = {
        // supplier_id: this.targetSupplierId,
        supplier_id: 0, // 暂时使用这个
        uid: this.targetSupplierUid,
        page: this.page,
      };

      if (this.filters.goodsType.value) {
        params.type = this.filters.goodsType.value;
      }
      if (this.filters.goodsSubType.value) {
        params.brand_type_id = this.filters.goodsSubType.value;
      }
      if (this.productName) {
        params[keywordName] = this.productName;
      }
      // if (this.widthRangeList[this.widthRangeIndex]) {
      //   params.width_scope = this.widthRangeList[this.widthRangeIndex];
      // }

      this.$get(url, params, (res) => {
        this.productList = res.data.list;
        this.allpage = Math.ceil(parseInt(res.data.total) / 12);
      });
    },
    // 筛选条件删除
    handleTagClose(key) {
      this.filters[key].value = "";
      if (key == "goodsType") {
        this.filters.goodsSubType.value = "";
      }
      this.getProductList(1);
    },
    // 跳转购物车
    gotoShopCar() {
      this.$router.push({
        name: "personalCenterShopCar",
      });
    },

    // 处理关键词搜索
    handleProductNameSearch() {
      this.getProductList(1);
    },
    //去商品详情
    commodityDetails(item) {
      let routerName = "commodityDetail";
      if (
        this.filters.goodsType.value == "cabinet" ||
        this.filters.goodsType.value == "shutter"
      ) {
        routerName = "ModelDisplay";
      }
      item.supplierId = this.targetSupplierId;
      item.part_type = this.filters.goodsType.value; // 柜体和门窗的类型给加上
      window.sessionStorage.setItem("productInfo", JSON.stringify(item));
      this.$router.push({
        name: routerName,
      });
    },
    commodityDetailsback() {
      this.carShow = false;
      this.commodityDetailsShow = false;
      this.shoppingMallShow = true;
    },
    //购物车
    shoppingCarShow() {
      // console.log('去购物车')
      this.carShow = true;
      this.shoppingMallShow = false;
      this.commodityDetailsShow = false;
    },
    backShop() {
      let local = localStorage.getItem("shopCar");
      if (localStorage.data) {
        if (local) {
          this.shopCarNum = JSON.parse(local)[this.uid].length;
        }
      } else {
        this.shopCarNum = 0;
      }

      this.carShow = false;
      this.commodityDetailsShow = false;
      this.shoppingMallShow = true;
    },

    totalSupplierChange() {
      //选择所有供应商
      this.isActive = true;
      this.supplierId = 0;
      this.totalWarehouseValue = "";
      this.supplierValue = "";
      this.subWarehouseValue = "";
      this.getList();
    },
    totalWarehouseChange(value) {
      //选择总仓
      // console.log('选择总仓',value)
      this.supplierValue = "";
      this.subWarehouseValue = "";
      this.supplierId = value;
      this.isActive = false;
      this.getList();
      let depotFilter = {
        name: this.totalWarehouseOptions.filter((item) => {
          if (item.value == value) {
            return item;
          }
        })[0].label,
        supplierId: value,
        identity: 2,
      };
      localStorage.setItem("depotFilterValue", JSON.stringify(depotFilter));
    },
    subWarehouseChange(value) {
      //选择分仓
      // console.log('选择分仓',value)

      this.totalWarehouseValue = "";
      this.supplierValue = "";
      this.supplierId = value;
      this.isActive = false;
      this.getList();
      console.log(this.subWarehouseOptions);
      let depotFilter = {
        name: this.subWarehouseOptions.filter((item) => {
          if (item.value == value) {
            return item;
          }
        })[0].label,
        supplierId: value,
        identity: 1,
      };
      localStorage.setItem("depotFilterValue", JSON.stringify(depotFilter));
    },
    supplierChange(value) {
      //选择供应商
      // console.log('选择供应商',value)

      this.totalWarehouseValue = "";
      this.subWarehouseValue = "";
      this.supplierId = value;
      this.isActive = false;
      this.getList();
      let depotFilter = {
        name: this.supplierOptions.filter((item) => {
          if (item.value == value) {
            return item;
          }
        })[0].label,
        supplierId: value,
        identity: 0,
      };
      localStorage.setItem("depotFilterValue", JSON.stringify(depotFilter));
    },
    toSupplierDetails(supplier_id) {
      this.$router.push({
        path: "/priceReport/" + supplier_id,
      });
    },
    dev(now) {
      this.now = now;
      if (now == "板材") {
        (this.com_type = "plank"), this.getList();
      } else if (now == "五金") {
        this.com_type = "hardware";

        this.getList();
      } else if (now == "封边") {
        this.com_type = "edge";
        this.getList();
      } else if (now == "柜门") {
        this.com_type = "door";
        this.getList();
      } else if (now == "其他") {
        this.com_type = "other";
        this.getList();
      }
      // console.log(this.com_type)
    },

    clearSearch() {
      this.seachValue = "";
    },
    typeChange(value) {
      //板材二级筛选 板材分类
      // console.log(value)
      let typeValue = value;
      if (typeValue == "所有板材") {
        this.getType = "";
      } else {
        this.getType = typeValue;
      }
      this.getList();
    },
    thickChange(value) {
      //板材二级筛选 基材分类
      let thickValue = value;
      if (thickValue == "所有基材") {
        this.getThick = "";
      } else {
        this.getThick = thickValue;
      }
      this.getList();
    },
    hardwareChange(value) {
      //五金二级分类
      let hardwareValue = value;
      if (hardwareValue == "所有五金") {
        this.getType = "";
      } else {
        this.getType = hardwareValue;
      }
    },
    doorChange(value) {
      //门板分类
      let doorValue = value;
      if (doorValue == "所有门板") {
        this.getType = "";
      } else {
        this.getType = doorValue;
      }
    },
    otherChange() {
      //其他分类
      let otherValue = value;
      if (otherValue == "所有分类") {
        this.getType = "";
      } else {
        this.getType = otherValue;
      }
    },
    getMore(status) {
      if (status == "re") {
        --this.page;
      } else {
        ++this.page;
      }
      this.getProductList();
      // let params = {}
      // let data = {};
      // if (this.now == "板材" || this.now == "封边") {
      //   if (status == "re") {
      //     --this.page;
      //   } else {
      //     ++this.page;
      //   }
      //   this.$get(
      //     "/py/erp/get_edge_commodity",
      //     {
      //       commodity_type: this.com_type, //分类(筛选功能，一级分类(plank等，默认plank))
      //       supplier_id: this.supplierId,
      //       page: this.page,
      //     },
      //     (res) => {
      //       let list = res.data.data_list;
      //       this.productList = list;
      //     }
      //   );
      // } else {
      //   if (status == "re") {
      //     data = {
      //       supplier_id: this.supplierId,
      //       commodity_type: this.com_type,
      //       page: --this.page,
      //     };
      //   } else {
      //     data = {
      //       supplier_id: this.supplierId,
      //       commodity_type: this.com_type,
      //       page: ++this.page,
      //     };
      //   }
      //   this.$get("/py/erp/get_other_commodity", data, (res) => {
      //     let list = res.data.commodity_list;
      //     this.productList = list;
      //   });
      // }
    },
    // 获取列表
    getList() {
      this.page = 1;
      let now = this.now;
      let url = ``;
      let JsonData = {};
      if (now == "板材") {
        this.$get(
          "/py/erp/get_edge_commodity",
          {
            supplier_id: this.supplierId,
            commodity_type: this.com_type,
            page: this.page,
          },
          (res) => {
            let list = res.data.data_list;
            let total = res.data.total;
            this.allpage = Math.ceil(parseInt(total) / 12);
            this.productList = list;
          }
        );
      } else if (now == "五金") {
        this.$get(
          "/py/erp/get_other_commodity",
          {
            supplier_id: this.supplierId,
            commodity_type: this.com_type,
          },
          (res) => {
            let list = res.data.commodity_list;
            let total = res.data.total;
            this.allpage = Math.ceil(parseInt(total) / 12);
            this.productList = list;
          }
        );
      } else if (now == "封边") {
        this.$get(
          "/py/erp/get_edge_commodity",
          {
            supplier_id: this.supplierId,
            commodity_type: this.com_type,
            page: this.page,
          },
          (res) => {
            let list = res.data.data_list;
            let total = res.data.total;
            this.allpage = Math.ceil(parseInt(total) / 12);
            this.productList = list;
          }
        );
      } else if (now == "柜门") {
        this.$get(
          "/py/erp/get_other_commodity",
          {
            supplier_id: this.supplierId,
            commodity_type: this.com_type,
          },
          (res) => {
            let list = res.data.commodity_list;
            let total = res.data.total;
            this.allpage = Math.ceil(parseInt(total) / 12);
            this.productList = list;
          }
        );
      } else if (now == "其他") {
        this.$get(
          "/py/erp/get_other_commodity",
          {
            supplier_id: this.supplierId,
            commodity_type: this.com_type,
          },
          (res) => {
            let list = res.data.commodity_list;
            let total = res.data.total;
            this.allpage = Math.ceil(parseInt(total) / 12);
            this.productList = list;
          }
        );
      }
    },
    getSupplierList() {
      const provinceAndCity = this.filters.area.label.split("/");
      const province = provinceAndCity[0];
      const city = provinceAndCity[1];
      return new Promise((resolve, reject) => {
        this.$get(
          "/py/erp/get_city_outlets",
          {
            province,
            city,
            outlets: "factory_status",
          },
          (res) => {
            let list = [];
            if (res.status == 1) {
              list = res.data;
            }
            this.supplierList = list;
            const supplierListSelections = [];
            list.forEach((item) => {
              supplierListSelections.push({
                label: item.brand || item.name,
                value: item.uid,
                supplier_id: item.supplier_id,
                // all: {
                //   label: item.name,
                //   value: item.uid,
                //   supplierId: item.id
                // },
              });
              // if (item.uid == this.defaultSupplierUid) {
              //   this.filters.supplier.value = item.uid;
              //   this.filters.supplier.label = item.name;
              // }
            });
            this.supplierSelections = supplierListSelections;
            resolve();
          },
          (err) => {
            reject();
          }
        );
      });
    },
    // 获取商品分类
    getProductCategorys(supplierUid, supplierId) {
      return new Promise((resolve, reject) => {
        this.$get(
          `/py/erp/get_brand_type_list?uid=${supplierUid}&supplier_id=${supplierId}`,
          {},
          (res) => {
            // const typeList = res.data.filter((item) => {
            //   return categorys.find((category) => {
            //     return item.type == category;
            //   }) // 仅显示门窗柜类商品
            //   // return item.type == "shutter" || item.type == 'furniture' || item.type == 'woodenDoor' || item.type == 'cabinet' || item.type == 'other';
            // });

            // 默认显示所有门窗柜的分类，不管当前供应商有没有
            const typeListKinds = categorys.reduce(
              (a, category) => {
                let targetItem = res.data.find((item) => {
                  return item.type == category.type;
                });
                if (targetItem) {
                  a.includes.push(targetItem);
                } else {
                  a.excludes.push({
                    type: category.type,
                    name: category.name,
                    brand_type_list: [],
                  });
                }
                return a;
              },
              {
                includes: [],
                excludes: [],
              }
            );
            const typeList = typeListKinds.excludes.concat(
              typeListKinds.includes
            );
            this.productCategorys = typeList.map((item) => {
              return {
                value: item.type,
                label: item.name,
                subTypes: item.brand_type_list
                  .filter((subType) => {
                    return subType.brand_type !== "";
                  })
                  .map((subType) => {
                    return {
                      value: subType.brand_type_id,
                      label: subType.brand_type,
                    };
                  }),
              };
            });
            if (this.productCategorys[0]) {
              this.filters.goodsType.value = this.productCategorys[0].value;
              this.filters.goodsType.label = this.productCategorys[0].label;
              if (this.productCategorys[0].subTypes[0]) {
                this.filters.goodsSubType.value = this.productCategorys[0].subTypes[0].value;
                this.filters.goodsSubType.label = this.productCategorys[0].subTypes[0].label;
              } else {
                this.filters.goodsSubType.value = "";
                this.filters.goodsSubType.label = "";
              }
            } else {
              this.filters.goodsType.value = "";
              this.filters.goodsType.label = "";
            }
            resolve();
          },
          (err) => {
            reject();
          }
        );
      });
    },
    addCar(productId) {
      // 判断是否登录
      // console.log('添加购物车',productId)
      let userData = localStorage.getItem("data");
      if (userData) {
        this.uid = JSON.parse(userData).id;
        let carNow = {};
        let uid = this.uid;
        let local = localStorage.getItem("shopCar");
        if (local) {
          let localCar = JSON.parse(localStorage.getItem("shopCar"));
          if (!localCar[uid] || localCar[uid].length == 0) {
            // 本地购物车存在，但是数组为空时
            carNow[uid] = [];
            this.productList.forEach((item, index) => {
              if (item.id == productId) {
                // 无库存提示
                // if(item.num == 0){
                //     this.$message.warning('暂无库存')
                //     return
                // }else{
                //     if(item.id == productId){
                //         carNow[uid].push(item)
                //     }
                //     this.$message.success('添加成功')
                // }
                if (item.id == productId) {
                  carNow[uid].push(item);
                }
                this.$message.success("添加成功");
              }
            });
            this.shopCarNum = carNow[uid].length;
            localStorage.setItem("shopCar", JSON.stringify(carNow));
          } else {
            let saveState;
            let a;
            // 再次判断购物车是否有该商品
            localCar[uid].forEach((item, index) => {
              // 如果购物车中已经存在该商品，数量加1
              if (item.id == productId) {
                item.number++;
                localStorage.setItem("shopCar", JSON.stringify(localCar));
                saveState = 2;
              } else {
                a = localCar[uid].filter(function (x) {
                  if (x.id == productId) {
                    return x;
                  }
                });
                // 有两个以上商品时
                if (!a.length) {
                  this.productList.forEach((items, index) => {
                    // 无库存提示
                    // if(items.num == 0){
                    //     if(items.id == productId){

                    //         saveState = 1
                    //     }
                    // }else{
                    //     if(items.id == productId){
                    //         localCar[uid].push(items)
                    //     }
                    //     saveState = 2
                    // }
                    if (items.id == productId) {
                      localCar[uid].push(items);
                    }
                    saveState = 2;
                  });
                  this.shopCarNum = localCar[uid].length;
                  localStorage.setItem("shopCar", JSON.stringify(localCar));
                }
              }
            });
            if (saveState == 1) {
              this.$message.warning("暂无库存");
            } else {
              this.$message.success("添加成功");
            }
          }
        } else {
          // 还没有加入过购物车，在本地建立购物车存储
          carNow[uid] = [];
          this.productList.forEach((item, index) => {
            if (item.id == productId) {
              // if(item.num == 0){
              //     this.$message.warning('暂无库存')
              // }else{
              //     // 无库存提示
              //     if(item.id == productId){
              //         carNow[uid].push(item)
              //     }
              //     this.$message.success('添加成功')
              // }
              if (item.id == productId) {
                carNow[uid].push(item);
              }
              this.$message.success("添加成功");
            }
          });
          this.shopCarNum = carNow[uid].length;
          localStorage.setItem("shopCar", JSON.stringify(carNow));
        }
      } else {
        let pageTo = encodeURIComponent(location.href);
        // location.href = 'https://www.guigui.com.cn/login.html?other=true&pageTo=' + pageTo
        // location.href='./login.html?pageTo='+pageTo
        if (process.env.NODE_ENV == "development") {
          location.href =
            "http://localhost:8010/login.html?other=true&pageTo=" + pageTo;
        } else {
          location.href = "./login.html?pageTo=" + pageTo;
        }
      }
    },
  },
  computed: {
    ...mapState(["userInfo", "supplierInfo", "userDfv", "shopCarInfo"]),
    searchingPlaceholder() {
      switch (this.filters.goodsType.value) {
        case "plank":
        case "edge":
          return "请输入板材/封边颜色名";
        default:
          return "请输入商品名";
          break;
      }
    },
    targetSupplierId() {
      if (!this.supplierList.length) return 0;
      const supplier = this.supplierList.find((item) => {
        return item.uid == this.filters.supplier.value;
      });
      if (supplier) {
        return supplier.supplier_id;
      }
      return 0;
    },
    targetSupplierUid() {
      if (!this.supplierList.length) return 0;
      const supplier = this.supplierList.find((item) => {
        return item.uid == this.filters.supplier.value;
      });
      if (supplier) {
        return supplier.uid;
      }
      return 0;
    },
    filterResults() {
      const result = Object.keys(this.filters)
        .filter((item) => {
          return item !== "area"; // 地区和宽度范围不显示在筛选中
        })
        .map((filter) => {
          return {
            label: this.filters[filter].label,
            type: this.filters[filter].type,
            value: this.filters[filter].value,
            key: filter,
          };
        });
      // 过滤value为''的选项
      return result.filter((item) => {
        return item.value !== "";
      });
    },
    filterRows() {
      const targetType = this.productCategorys.findIndex((item) => {
        return item.value == this.filters.goodsType.value;
      });
      const result = [
        {
          label: "地区",
          key: "area",
          type: "selection",
          disabled: !!this.userDfv,
          selections: getProvinceData(),
          showAllLevel: true,
        },
        {
          label: "门店",
          key: "supplier",
          type: "radio",
          disabled: !!this.userDfv,
          selections: this.supplierSelections,
        },
        {
          label: "商品",
          key: "goodsType",
          type: "radio",
          selections: this.productCategorys,
        },
        {
          label: "分类",
          key: "goodsSubType",
          type: "radio",
          selections: this.productCategorys[targetType]
            ? this.productCategorys[targetType].subTypes
            : [],
        },
      ];
      if (this.userDfv) {
        result.unshift();
      }
      return result;
    },
    shopCarStatus() {
      if (
        this.shopCarInfo[this.userInfo.id] &&
        this.shopCarInfo[this.userInfo.id].length !== 0
      ) {
        return "full";
      }
      return "empty";
    },
    setAtt() {
      let att = [];
      // console.log(this.com_type)
      for (let i in this.goodsAttribute) {
        if (this.filters.goodsType.value == i) {
          att = this.goodsAttribute[i];
        }
      }
      return att;
    },
  },
  watch: {
    userInfo(value) {
      let localCar = localStorage.getItem("shopCar");
      if (value.id && localCar) {
        this.shopCarNum = JSON.parse(localCar)[value.id].length;
      }
    },
  },
  async created() {
    // 控制单独dfv用户进入页面默认显示的供应商
    if (this.userDfv) {
      this.defaultSupplierUid = this.userDfv.uid;
      this.defaultSupplierId = this.userDfv.supplierId;
      this.filters.supplier.value = this.userDfv.uid;
      this.filters.supplier.label = this.userDfv.name;
    } else {
      await this.getSupplierList();
      this.defaultSupplierUid = this.supplierList[0]
        ? this.supplierList[0].uid
        : 0;
      this.defaultSupplierId = this.supplierList[0]
        ? this.supplierList[0].supplier_id
        : 0;
      this.filters.supplier.value = this.supplierList[0]
        ? this.supplierList[0].uid
        : 0;
      this.filters.supplier.label = this.supplierList[0]
        ? this.supplierList[0].name
        : "";
    }

    // 获取第一个供应商下的商品分类
    // await this.getProductCategorys(this.defaultSupplierUid, this.defaultSupplierId);
    await this.getProductCategorys(
      this.defaultSupplierUid,
      this.defaultSupplierId
    );

    // 获取该类商品的左栏筛选条件
    await this.getWidthRangeSelections();

    // 获取当前筛选条件下的商品
    this.getProductList(1);
  },
  mounted() {
    if (localStorage.getItem("depotFilterValue")) {
      // 取存sessionStorage，默认选择上次选择的仓库
      let depotData = JSON.parse(localStorage.getItem("depotFilterValue"));
      if (depotData.identity == 2) {
        this.totalWarehouseValue = depotData.name;
        this.supplierValue = "";
        this.subWarehouseValue = "";
      } else if (depotData.identity == 1) {
        this.subWarehouseValue = depotData.name;
        this.totalWarehouseValue = "";
        this.supplierValue = "";
      } else {
        this.supplierValue = depotData.name;
        this.totalWarehouseValue = "";
        this.subWarehouseValue = "";
      }
      this.supplierId = JSON.parse(
        localStorage.getItem("depotFilterValue")
      ).supplierId;
    }
    let param = autoLogin.getUrlVars();
    if (this.userDfv) {
      let dfv = this.userDfv;
      if (dfv.identity == 2) {
        this.totalWarehouseValue = dfv.name;
        this.supplierValue = "";
        this.subWarehouseValue = "";
      } else if (dfv.identity == 1) {
        this.subWarehouseValue = dfv.name;
        this.totalWarehouseValue = "";
        this.supplierValue = "";
      } else {
        this.supplierValue = dfv.name;
        this.totalWarehouseValue = "";
        this.subWarehouseValue = "";
      }
      this.supplierId = dfv.supplierId;
    }
    // this.$post(
    //   "/guigui/cloudStorage/getSupplierList",
    //   {
    //     status: 1,
    //   },
    //   (res) => {
    //     let supplierArr = res.data.list;
    //     for (let i in supplierArr) {
    //       if (supplierArr[i].identity == 0) {
    //         let obj = {
    //           value: supplierArr[i].id,
    //           label: supplierArr[i].name,
    //         };
    //         this.supplierOptions.push(obj);
    //       }
    //       if (supplierArr[i].identity == 1) {
    //         let obj = {
    //           value: supplierArr[i].id,
    //           label: supplierArr[i].name,
    //         };
    //         this.subWarehouseOptions.push(obj);
    //       }
    //       if (supplierArr[i].identity == 2) {
    //         let obj = {
    //           value: supplierArr[i].id,
    //           label: supplierArr[i].name,
    //         };
    //         this.totalWarehouseOptions.push(obj);
    //       }
    //     }
    //   }
    // );
    // let localCar = localStorage.getItem("shopCar");
    // if (this.userInfo.id) {
    //   this.uid = this.userInfo.id;
    //   if (localCar) {
    //     // 获取购物车数量
    //     this.shopCarNum = JSON.parse(localCar)[this.uid]
    //       ? JSON.parse(localCar)[this.uid].length
    //       : 0;
    //   }
    // } else {
    //   this.shopCarNum = 0;
    // }
    this.$post(
      "/py/erp/get_cloud_user_setting",
      {
        supplier_id: this.supplierId,
        uid: this.uid,
      },
      (res) => {
        let arr = res.data.plank_part_type_setting;
        for (let i in arr) {
          let obj = {
            value: arr[i],
            label: arr[i],
          };
          this.options.type.push(obj);
        }
      }
    );

    // this.getList();
    // this.totalWarehouseChange(19)
  },
};
</script>
